export default "/google.png";